import React, {useState, useEffect} from "react";
import {Form } from "react-bootstrap";
import loadable from "@loadable/component"
//import Select from 'react-select';
import {
    calculate,
    countries,
} from "@starberry/react-calculator-stampduty"

import {CalculatorFields, rentalYieldResult} from "../../../common/utils/mortgage"
import {addCommas, numericWithDecimal, numberFormat} from "../../../common/utils/site_utlis"
import {currency} from "../../../common/constant"

const Select = loadable(() => import("react-select"));


const RentalYield = ({price, title}) => {

    const [calculator_value, setCalculatorValue] = useState({'purchase_price': price, "monthly_rent": '5000'});
    const[yieldResult, setYieldResult] = useState('');
    const [error_msg, setErrorMsg] = useState('');

    const propertyValue = calculator_value.purchase_price;
    const monthly_rent = calculator_value.monthly_rent;

    useEffect(()=>{
        console.log("property_type", propertyValue,monthly_rent);
        //console.log("stampDuty", stampDuty);
        let annual_rent = monthly_rent * 12
        let rental_res = rentalYieldResult(propertyValue, annual_rent)
        setYieldResult(rental_res);

    },[propertyValue, monthly_rent])


    const handleChange = (event, field_name) => {

        if(field_name === "monthly_rent"){
            if (parseFloat(numericWithDecimal(document.getElementById("monthly_rent").value)) > parseFloat(numericWithDecimal(document.getElementById("purchase_price").value))) {
                setErrorMsg("Monthly rent should not be greater than property price.")
            } else {
                setErrorMsg("");
                setCalculatorValue({...calculator_value, [event.target.name]: numericWithDecimal(event.target.value)})
            }
        } else{
            setCalculatorValue({...calculator_value, [event.target.name]: numericWithDecimal(event.target.value)})
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'calculator',
            'formType': title,
            'formName': title,
            'formLabel': title
        });
    }

    return (
        <React.Fragment>
            <div className="tab-wrapper">
                <Form action="javascript:;">
                    {error_msg && <div className="alert alert-danger col-12 p-3">{error_msg}</div>}

                    <Form.Group className="form-wrap">
                        <Form.Label>Property Price ({currency})</Form.Label>
                        <Form.Control type="text" name="purchase_price" id="purchase_price" value={addCommas(calculator_value.purchase_price)} onChange={handleChange} maxLength={CalculatorFields.PriceInputMax}/>
                    </Form.Group>
                    <Form.Group className="form-wrap">
                        <Form.Label>Monthly Rent ({currency})</Form.Label>
                        <Form.Control type="text" name="monthly_rent" id="monthly_rent" onChange={(e) => handleChange(e, "monthly_rent")} value={addCommas(calculator_value.monthly_rent)}/>
                    </Form.Group>
                </Form>
                <div className="bottom-content">
                    <div className="sm-info">
                        <span className="bold-text">{yieldResult}%</span>
                        <span className="time">Estimated rental yield</span>                
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default RentalYield;